<template>
  <div class="page-bookdetail common-page"> 
    <div class="page-header fx-vb">
      <div class="btn-act back" @click="pageBack">
      </div>
      <h1 class="page-title">
      </h1>
      <div class="btn-act"></div>
    </div>
    <div class="page-con nop">
      <div class="book-detail fx-vb">
        <div class="cover">
          <img loading="lazy" :src="bookData.avatar" alt="">
        </div>
        <div class="detail">
          <div class="name">
            {{ bookData.name }}
          </div>
          <div class="auther">
            {{ bookData.author }}
          </div>
          <div class="info">
            <span>{{ bookData.chapter_count }} Chapters</span> ·
            <span v-if="bookData.is_complete">Completed</span>
            <span v-else>OnGoing</span>
          </div>
        </div>
      </div>
      <div class="book-intro">
        <div class="book-num fx-vc">
          <div class="reviews">
            <strong>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="10.049178123474121" height="9.654997825622559" viewBox="0 0 10.049178123474121 9.654997825622559"><g><path d="M4.19972,0.434682C4.59693,-0.144894,5.45225,-0.144894,5.84946,0.434682C5.84946,0.434682,6.93959,2.0253,6.93959,2.0253C7.06962,2.21503,7.26108,2.35414,7.48171,2.41918C7.48171,2.41918,9.33139,2.96442,9.33139,2.96442C10.0053,3.16309,10.2696,3.97655,9.84119,4.53342C9.84119,4.53342,8.66524,6.06172,8.66524,6.06172C8.52498,6.24402,8.45185,6.46909,8.45817,6.69902C8.45817,6.69902,8.51119,8.62662,8.51119,8.62662C8.5305,9.32899,7.83853,9.83169,7.17652,9.59629C7.17652,9.59629,5.35964,8.95023,5.35964,8.95023C5.14292,8.87317,4.90626,8.87317,4.68954,8.95023C4.68954,8.95023,2.87266,9.59629,2.87266,9.59629C2.21065,9.83169,1.51868,9.32899,1.53799,8.62662C1.53799,8.62662,1.59101,6.69902,1.59101,6.69902C1.59733,6.46909,1.5242,6.24402,1.38394,6.06172C1.38394,6.06172,0.208029,4.53342,0.208029,4.53342C-0.220433,3.97655,0.0438785,3.16309,0.717829,2.96442C0.717829,2.96442,2.56747,2.41918,2.56747,2.41918C2.7881,2.35414,2.97956,2.21503,3.10959,2.0253C3.10959,2.0253,4.19972,0.434682,4.19972,0.434682C4.19972,0.434682,4.19972,0.434682,4.19972,0.434682Z" fill="#FF5E5E" fill-opacity="1"/></g></svg>
              {{ bookData.start_count }}
            </strong>
            <span>Reviews</span>
          </div>
          <div class="words">
            <strong v-html="wordNum"></strong>
            <span>Words</span>
          </div>
        </div>
        <div class="summary">
          <h3>Summary</h3>
          <div class="the-txt">
            <p>
              {{ bookData.summary }}
            </p>
          </div>
        </div>
      </div>
      <div class="book-act fx-vc">
        <div class="btn btn-addShelf" :class="{faved: bookData.is_fav}" @click="addToBookShelf">
            <svg v-if="bookData.is_fav" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="18.850374221801758" height="17.38704490661621" viewBox="0 0 18.850374221801758 17.38704490661621"><g><path d="M17.3333,0C17.3744,0,17.4337,0.0249724,17.4908,0.0652609C17.7901,0.191883,18,0.488091,18,0.833333C18,1.12872,17.8463,1.38821,17.6145,1.53621C17.2251,2.15278,17,2.88344,17,3.66667C17,4.44981,17.2251,5.18039,17.614,5.79726C17.8462,5.94487,18,6.20447,18,6.5C18,6.87331,17.7545,7.18929,17.4162,7.29533C17.3867,7.31988,17.3583,7.33333,17.3333,7.33333C17.3333,7.33333,17.1757,7.333,17.1757,7.333C17.1757,7.333,17.1667,7.33333,17.1667,7.33333C17.1636,7.33333,17.1606,7.33332,17.1576,7.33329C17.1576,7.33329,3.66667,7.33333,3.66667,7.33333C1.64162,7.33333,0,5.69171,0,3.66667C0,1.64162,1.64162,0,3.66667,0C3.66667,0,17.3333,0,17.3333,0C17.3333,0,17.3333,0,17.3333,0ZM15.6972,1.66667C15.6972,1.66667,3.66667,1.66667,3.66667,1.66667C2.5621,1.66667,1.66667,2.5621,1.66667,3.66667C1.66667,4.77124,2.5621,5.66667,3.66667,5.66667C3.66667,5.66667,15.6972,5.66667,15.6972,5.66667C15.461,5.04045,15.3333,4.36523,15.3333,3.66667C15.3333,2.9681,15.461,2.29288,15.6972,1.66667C15.6972,1.66667,15.6972,1.66667,15.6972,1.66667ZM18.6063,12.6629C18.9176,12.9742,18.9311,13.4705,18.6469,13.7979C18.6469,13.7979,18.6063,13.8414,18.6063,13.8414C18.6063,13.8414,15.3502,17.0978,15.3502,17.0978C15.3369,17.1132,15.3229,17.1283,15.3082,17.143C14.991,17.4601,14.4818,17.4682,14.1549,17.1672C14.1549,17.1672,14.128,17.1413,14.128,17.1413C14.128,17.1413,12.2441,15.2574,12.2441,15.2574C11.9186,14.9319,11.9186,14.4043,12.2441,14.0788C12.5695,13.7534,13.0972,13.7534,13.4226,14.0788C13.4226,14.0788,14.717,15.3732,14.717,15.3732C14.717,15.3732,17.4278,12.6629,17.4278,12.6629C17.7532,12.3375,18.2809,12.3375,18.6063,12.6629C18.6063,12.6629,18.6063,12.6629,18.6063,12.6629ZM13.1667,9.33333C13.6269,9.33333,14,9.70643,14,10.1667C14,10.6269,13.6269,11,13.1667,11C13.1667,11,2.30283,11,2.30283,11C2.53904,11.6262,2.66667,12.3014,2.66667,13C2.66667,13.6986,2.53904,14.3738,2.30283,15C2.30283,15,9.83333,15,9.83333,15C10.2936,15,10.6667,15.3731,10.6667,15.8333C10.6667,16.2936,10.2936,16.6667,9.83333,16.6667C9.83333,16.6667,0.666667,16.6667,0.666667,16.6667C0.641505,16.6667,0.612876,16.653,0.583215,16.6285C0.245184,16.5223,0,16.2064,0,15.8333C0,15.5375,0.154118,15.2777,0.386436,15.1298C0.775121,14.5131,1,13.7828,1,13C1,12.2172,0.775121,11.4869,0.38644,10.8702C0.15412,10.7223,0,10.4625,0,10.1667C0,9.82161,0.209714,9.52554,0.508636,9.39896C0.565986,9.35846,0.625469,9.33333,0.666667,9.33333C0.666667,9.33333,13.1667,9.33333,13.1667,9.33333C13.1667,9.33333,13.1667,9.33333,13.1667,9.33333Z" fill="#FFFFFF" /></g></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="19.041248321533203" height="17.49991798400879" viewBox="0 0 19.041248321533203 17.49991798400879"><g transform="matrix(-1,0,0,1,38.082496643066406,0)"><path d="M37.2350483215332,6.25C37.25244832153321,6.29415,37.270348321533206,6.33814,37.2888483215332,6.38197C37.4855483215332,6.84915,37.741648321533205,7.29775,38.057148321533205,7.71657C38.1191483215332,7.7989,38.0604483215332,7.91667,37.9573483215332,7.91667L23.416158321533203,7.91667C21.230038321533204,7.91667,19.457828321533203,6.14446,19.457828321533203,3.95833C19.457828321533203,1.77221,21.230038321533204,0,23.416158321533203,0L37.9573483215332,0C38.0604483215332,0,38.1191483215332,0.11777,38.057148321533205,0.200097C37.741648321533205,0.618914,37.4855483215332,1.06752,37.2888483215332,1.5347C37.270348321533206,1.57853,37.25244832153321,1.62252,37.2350483215332,1.66667C36.6550483215332,3.13739,36.6550483215332,4.77928,37.2350483215332,6.25ZM21.795708321533205,5.57879Q21.124498321533203,4.90757,21.124498321533203,3.95833Q21.124498321533203,3.0091,21.795708321533205,2.33788Q22.466928321533203,1.66667,23.416158321533203,1.66667L35.4610483215332,1.66667Q35.133348321533205,2.75769,35.133348321533205,3.95833Q35.133348321533205,5.15897,35.4610483215332,6.25L23.416158321533203,6.25Q22.466928321533203,6.25,21.795708321533205,5.57879ZM24.980218321533204,10.4166C24.980218321533204,9.95635,25.3533183215332,9.58325,25.813558321533204,9.58325L33.8562483215332,9.58325C36.035348321533206,9.58325,37.7911483215332,11.3614,37.7911483215332,13.5416C37.7911483215332,15.7218,36.035348321533206,17.4999,33.8562483215332,17.4999L27.480228321533204,17.4999C27.019988321533205,17.4999,26.646888321533204,17.1268,26.646888321533204,16.6666C26.646888321533204,16.2063,27.019988321533205,15.8333,27.480228321533204,15.8333L33.8562483215332,15.8333C35.10304832153321,15.8333,36.12444832153321,14.8132,36.12444832153321,13.5416C36.12444832153321,12.27,35.10304832153321,11.2499,33.8562483215332,11.2499L25.813558321533204,11.2499C25.3533183215332,11.2499,24.980218321533204,10.8768,24.980218321533204,10.4166ZM21.541248321533203,16.6666L21.541248321533203,14.9999L19.874583321533205,14.9999C19.414345321533204,14.9999,19.041248321533203,14.6268,19.041248321533203,14.1666C19.041248321533203,13.7063,19.414345321533204,13.3333,19.874583321533205,13.3333L21.541248321533203,13.3333L21.541248321533203,11.6666C21.541248321533203,11.2063,21.914348321533204,10.8333,22.374578321533203,10.8333C22.834818321533202,10.8333,23.207918321533203,11.2063,23.207918321533203,11.6666L23.207918321533203,13.3333L24.874578321533203,13.3333C25.334818321533202,13.3333,25.707918321533203,13.7063,25.707918321533203,14.1666C25.707918321533203,14.6268,25.334818321533202,14.9999,24.874578321533203,14.9999L23.207918321533203,14.9999L23.207918321533203,16.6666C23.207918321533203,17.1268,22.834818321533202,17.4999,22.374578321533203,17.4999C21.914348321533204,17.4999,21.541248321533203,17.1268,21.541248321533203,16.6666Z" fill-rule="evenodd" fill="#FFFFFF" fill-opacity="1"/></g></svg>
        </div>
        <div class="btn btn-reader" @click="readBook">
          Read Now
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { apiGetBookDetail, apiAddBookShelf } from '@/api';
import { numberFormat } from '@/util';

export default {
  name: 'BookList',
  data() {
    return {
      bookId: 0,
      bookData: {}
    }
  },
  components: {    
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
    }),
    wordNum() {
      return numberFormat(this.bookData.words_count)
    }
  }, 
  methods: {
    pageBack() {
      sessionStorage.removeItem(`bookDetail${this.bookId}`)
      this.$router.back()
    },
    readBook() {
      if(!this.bookData.id) return;
      sessionStorage.setItem(`bookDetail${this.bookId}`, JSON.stringify(this.bookData))
      this.$router.push({
        name: 'BookReader',
        params: {
          id: this.bookId
        }
      })
    },
    async getBookData() {
      const bookD = sessionStorage.getItem(`bookDetail${this.bookId}`);
      if(bookD) {
        const pbookD = JSON.parse(bookD);
        if (pbookD.avatar.indexOf('http') === -1){
          pbookD.avatar = `https://static.novellettes.com/${pbookD.avatar}`
        }
        this.bookData = pbookD;
        this.$toast.clear();
        return;
      }
      
      const {code ,data} = await apiGetBookDetail({
        id: this.bookId
      })
      this.$toast.clear();
      if(code) return;
      data.avatar = data.avatar.indexOf('http') === -1 ? `https://static.novellettes.com/${data.avatar}` : data.avatar;
      this.bookData = data;
    },
    async addToBookShelf() {
      if(this.bookData.is_fav) return;
      if(!this.isLogin) {
        this.$store.commit('setShowLogin', true)
        return;
      }
      this.$toast.loading({
        duration: 0
      })
      const {code ,data} = await apiAddBookShelf({
        book_id: this.bookData.id,
        book_name: this.bookData.name,
        avatar: this.bookData.avatar.indexOf('http') === -1 ? `https://static.novellettes.com/${this.bookData.avatar}` : this.bookData.avatar
      })
      this.bookData.is_fav = true;
      this.$toast.success('The book has been added to the bookshelf')
      console.log(code, data)
    }
  },
  mounted() {
    this.$toast.loading({
      duration: 0
    })
    const bookId = this.$route.params.id;
    if(!bookId) return;
    this.bookId = bookId;
    this.getBookData()
  }
}
</script>

<style lang="less">
@import url("./index.less");
</style>